import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Divider, Grid, Segment } from "semantic-ui-react";
import { RootState } from "../../../../app/store/configureStore";
import { Student } from "../../../students/types";
import { downloadFile } from "../../../../app/helpers/fileHelper";
import agent from "../../../../app/api/agent";
import StudentProfileAgreementGuide from "./StudentProfileAgreementGuide";
import ButtonLink from "../../../../components/ButtonLink";
import { userActions } from "../../../user/actions";
import { useAppDispatch } from "../../../../app/hooks/useAppDispatch";
import "./styles.less";
import Loader from "../../../../components/Loader";

interface Props {
  student: Student;
}

const StudentProfileAgreementPending = ({ student }: Props) => {
  const { t } = useTranslation();
  const agreementState = useSelector((state: RootState) => state.currentUser.agreement);
  const dispatch = useAppDispatch();
  const [isCheckingStatus, setCheckingStatus] = useState(false);

  const reset = () => {
    dispatch(userActions.updateUser({ agreement: { status: "none" } }));
  };

  const checkStatus = async () => {
    try {
      setCheckingStatus(true);
      const status = await agent.Students.checkStatus(student.id);
      dispatch(userActions.updateUser({ agreement: { status: status } }));
      const userProfile = await agent.Students.getProfile();
      dispatch(userActions.updateUser({ ...userProfile, id: String(userProfile.id) }));
    } finally {
      setCheckingStatus(false);
    }
  };

  return (
    <>
      <p>{t("my_profile.student.agreement.virtual_sign_pending_text")}</p>
      <div className="agreement-pending-actions">
        {isCheckingStatus ? (
          <Loader />
        ) : (
          <>
            {agreementState?.signUrl && (
              <a href={agreementState?.signUrl} target="_blank" rel="noopener noreferrer">
                {t("my_profile.student.agreement.esign_url")}
              </a>
            )}
            <ButtonLink type="button" onClick={checkStatus} disabled={isCheckingStatus}>
              {t("my_profile.student.agreement.check_status")}
            </ButtonLink>
            <ButtonLink type="button" onClick={reset}>
              {t("my_profile.student.agreement.restart")}
            </ButtonLink>
          </>
        )}
      </div>
    </>
  );
};

export default StudentProfileAgreementPending;
